import { ActivityCategory } from 'ui/types/activities';
import { Ecosystem } from 'ui/types/ecosystem';

/**
 * This function is used in the activity edition.
 * Filters the causes of an activity definition based on the selected ecosystem.
 * @param activityDefinition The activity definition to sanitize.
 * @param selectedEcosystem The selected ecosystem.
 * @returns The sanitized causes.
 */
export const filterActivityCausesByEcosystem = (
  activityDefinition: { causeOptions: ActivityCategory[] },
  selectedEcosystem?: Ecosystem,
): string[] => {
  let causes =
    activityDefinition.causeOptions.map((cause) => cause?._id || '') || [];

  if (selectedEcosystem?.causeOptions?.length) {
    causes = activityDefinition.causeOptions
      .filter((cause) =>
        selectedEcosystem.causeOptions?.includes(cause?._id || ''),
      )
      .map((cause) => cause?._id || '');
  }

  return causes;
};
